<template>
  <div>
    <Head title="Reports" />
    <h1 class="mb-8 text-3xl font-bold">Reports</h1>
    <v-container>
      <v-row>
        <v-col lg="3" md="12">
          <v-card>
            <v-card-title>Courses</v-card-title>
            <v-card-text>
              <v-icon size="120" color="orange darken-2">mdi-school</v-icon>
              <span class="text-h1">{{ active_courses }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <Link href="/admin/reports/courses/">
                <v-btn icon color="orange darken-2">
                  <v-icon x-large>mdi-arrow-right-bold-circle-outline</v-icon>
                </v-btn>
              </Link>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col lg="3" md="12">
          <v-card>
            <v-card-title>User Courses</v-card-title>
            <v-card-text>
              <v-icon size="120" color="orange darken-2">mdi-account-school</v-icon>
              <span class="text-h1">{{ user_course_activity }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <Link href="/admin/reports/courses2/">
                <v-btn icon color="orange darken-2">
                  <v-icon x-large>mdi-arrow-right-bold-circle-outline</v-icon>
                </v-btn>
              </Link>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col lg="3" md="12">
          <v-card>
            <v-card-title>Jobs</v-card-title>
            <v-card-text class="justify-center align-center">
              <v-icon size=120
                  color="indigo">mdi-briefcase</v-icon>
              <span class="text-h1">{{ active_jobs }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <Link href="/admin/reports/jobs/">
                <v-btn icon color="indigo">
                  <v-icon x-large>mdi-arrow-right-bold-circle-outline</v-icon>
                </v-btn>
              </Link>
            </v-card-actions>
          </v-card>
        </v-col>
        
        <v-col lg="3" md="12">
          <v-card>
            <v-card-title>User Job Activity</v-card-title>
            <v-card-text class="justify-center align-center">
              <v-icon size=120
                  color="indigo">mdi-briefcase-account</v-icon>
              <span class="text-h1">{{ user_job_activity }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <Link href="/admin/reports/jobs2/">
                <v-btn icon color="indigo">
                  <v-icon x-large>mdi-arrow-right-bold-circle-outline</v-icon>
                </v-btn>
              </Link>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col lg="3" md="12">
          <v-card>
            <v-card-title>Users</v-card-title>
            <v-card-text>
              <v-icon size="120" color="purple">mdi-account</v-icon>
              <span class="text-h1">{{ users }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <Link href="/admin/reports/users/">
                <v-btn icon color="purple">
                  <v-icon x-large>mdi-arrow-right-bold-circle-outline</v-icon>
                </v-btn>
              </Link>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    
    
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue'
  import { Link } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyAdminLayout'
  import axios from 'axios'

export default {
  components: {
    Head,
    Link
  },
  props: {
    active_courses:Number,
    inactive_courses:Number,
    active_jobs:Number,
    inactive_jobs:Number,
    user_job_activity:Number,
    user_course_activity:Number,
    organizations:Number,
    users:Number,
    },
  data: () => ({
      labels: [
        '12am',
        '3am',
        '6am',
        '9am',
        '12pm',
        '3pm',
        '6pm',
        '9pm',
      ],
      value: [
        200,
        675,
        410,
        390,
        310,
        460,
        250,
        240,
      ],
    }),
  layout: Layout,
}
</script>

<style scoped>
  .v-sheet--offset {
    top: -24px;
    position: relative;
  }
</style>